import {BaseUrlService} from 'core/base/BaseUrlService';
import {FilterUrlService} from 'plugins/modules/filter/services/FilterUrlService';
import {PaginationUrlService} from 'plugins/modules/pagination/services/PaginationUrlService';
import {SearchUrlService} from 'plugins/modules/search/services/SearchUrlService';
import {SortUrlService} from 'plugins/modules/sorting/services/SortUrlService';

export class CommonUrlService extends BaseUrlService {
    public filterUrlService: FilterUrlService;
    public sortUrlService: SortUrlService;
    public paginationUrlService: PaginationUrlService;
    public searchUrlService: SearchUrlService;

    constructor(
        query: BaseUrlService['query'],
        onParamsChange: BaseUrlService['onParamsChange'],
        options: BaseUrlService['options']
    ) {
        super(query, onParamsChange, options);

        this.filterUrlService = new FilterUrlService(query, onParamsChange, options);
        this.sortUrlService = new SortUrlService(query, onParamsChange, options);
        this.paginationUrlService = new PaginationUrlService(query, onParamsChange, options);
        this.searchUrlService = new SearchUrlService(query, onParamsChange, options);
    }
}
